import React, { useCallback } from 'react';
import { Container } from 'react-bootstrap';
import { RouteComponentProps } from 'react-router';
import { DocumentTypeSelector } from '../../components';
import routes from '../../routes/routes';

interface DocumentTypeScreenParams {
    id: string;
}

type DocumentTypeScreenProps = RouteComponentProps<DocumentTypeScreenParams>;

export const DocumentTypeScreen: React.FC<DocumentTypeScreenProps> = ({ match, history }) => {
    const documentTypeId = match.params.id;

    const navigateToCreateDocumentType = useCallback(
        (isCategory) => {
            history.push({
                pathname: routes.createDocumentType,
                search: isCategory ? `?parentId=${documentTypeId}&isCategory=true` : `?parentId=${documentTypeId}`,
            });
        },
        [documentTypeId, history],
    );

    const navigateToDocumentType = useCallback(
        ({ id }) => {
            history.push(`/documenttype/${id}`);
        },
        [history],
    );

    return (
        <Container>
            <DocumentTypeSelector
                documentTypeId={documentTypeId}
                onClick={navigateToDocumentType}
                navigateToCreateDocumentType={navigateToCreateDocumentType}
            />
        </Container>
    );
};
